<div class="checkbox-tree">
  @for (node of data; track node) {
    <div
      class="tree-node"
      [ngStyle]="{ 'padding-left': getNodePadding(level) }"
      >
      <hyperkit-checkbox
        [checked]="node.checked || false"
        [indeterminate]="node.indeterminate || false"
        [label]="node.label"
        [disabled]="node.disabled || false"
        (click)="onNodeClick(node)"
      ></hyperkit-checkbox>
      @if (node.children?.length) {
        <hyperkit-checkbox-tree
          [data]="node.children ?? []"
          [level]="level + 1"
          CheckboxTreeSelection
          (nodeChange)="onChildNodeChange($event, node)"
        ></hyperkit-checkbox-tree>
      }
    </div>
  }
</div>
